import React, { useEffect, useRef, useState } from 'react'
import { IoMdClose } from 'react-icons/io'
import { IoSearch } from 'react-icons/io5'
import { useDispatch, useSelector } from 'react-redux';
import { getAllActiveBranches } from '../../../redux/BranchReducer/action';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getAuthToken } from "../../../utils/auth";

const AssignAnotherBranch = ({ closeModal, selectedOfficer, selectedBranch }) => {

    const { allActiveBranches } = useSelector((store) => {
        return {
            allActiveBranches: store.BranchReducer.allActiveBranches
        }
    }, []);

    // const tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // const authToken = tokens?.token || null;
    const authToken = getAuthToken();

    const [formData, setFormData] = useState({
        name: selectedOfficer?.name || '',
        emp_id: selectedOfficer?.employeeId || '',
        officer_id: selectedOfficer?.officerId || '',
        secondary_branch_code: '',
    });

    const [branchSearch, setBranchSearch] = useState('');
    const [showBranchDropdown, setShowBranchDropdown] = useState(false);
    const [selectedBranchDisplay, setSelectedBranchDisplay] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const searchInputRef = useRef(null);
    const dropdownRef = useRef(null);

    const dispatch = useDispatch();

    const [branchFilters, setBranchFilters] = useState({
        branch_code: '',
        branch_name: ''
    })

    useEffect(() => {
        dispatch(getAllActiveBranches(1, 2000, branchFilters));
    }, [branchFilters, dispatch]);

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            searchInputRef.current &&
            !searchInputRef.current.contains(event.target)
          ) {
            setShowBranchDropdown(false);
          }
    
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);

    const handleChange = (e) => {
        setFormData((prev) => ({ 
            ...prev, 
            [e.target.name]: e.target.value 
        }));
    };

    const handleBranchSearchChange = (e) => {
        setBranchSearch(e.target.value);
        setSelectedBranchDisplay('');
        setBranchFilters({
            branch_name: e.target.value
        });
    };

    const handleBranchSearchFocus = () => {
        if (allActiveBranches?.length > 0) {
            setShowBranchDropdown(true);
        }
    };

    const handleBranchSelect = (branch) => {
        setFormData((prev) => ({ 
            ...prev, 
            secondary_branch_code: branch.branch_code 
        }));
        setSelectedBranchDisplay(`${branch.branch_name}: ${branch.branch_code}`);
        setBranchSearch(`${branch.branch_name}: ${branch.branch_code}`);
        setShowBranchDropdown(false);
    };

    const handleBranchAssignment = async (e) => {
        e.preventDefault();

        if (!authToken) {
            toast.error('Missing or invalid authentication token.');
            return;
        }

        console.log("formdata: ", formData);

        const headers = {
            'Authorization': `Bearer ${authToken}`,
            'Content-type': 'application/json',
        }

        setSubmitLoading(true);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/officer/assign-secondary-branch`, formData, { headers });

            if (response.data.status) {
                console.log('Status toggled successfully:', response.data);
                toast.success(`${response?.data?.message}`);

                closeModal();
            } else {
                toast.error(response.data.message || 'Failed to assign another branch');
            }
        } catch (err) {
            let errorMsg = err?.response?.data?.message;
            toast.error(`${errorMsg}`);
        }
        finally {
            // closeModal();
            setSubmitLoading(false);
        }
    }

    return (
        <div>
            <div className="modal-overlay" onClick={closeModal}></div>

            <div className="add-user-modal">
                <div className="modal-header">
                    <h5>Assign Another Branch</h5>
                    <button className="close-btn" onClick={closeModal}>
                        <IoMdClose />
                    </button>
                </div>

                <p className="modal-subtitle">
                    Assign a secondary branch to the officer
                </p>

                <form 
                    className="add-user-modal-content" 
                    // onSubmit={handleBranchAssignment}
                >
                    {/* NAME */}
                    <div className="form-group-row">
                        <div className="autocomplete-wrapper">
                            <label>Officer Name</label>
                            <input
                                name="name"
                                value={formData.name}
                            />
                        </div>
                    </div>

                    {/* EMP ID */}
                    <div className="form-group-row">
                        <div className="autocomplete-wrapper">
                            <label>Employee ID</label>
                            <input
                                name="emp_id"
                                value={formData.emp_id}
                                // onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* BRANCH SEARCH */}
                    <div className="form-group-row">
                        <div className="branch-search-container">
                            <label>Branch</label>

                            <div className="search-input-wrapper" ref={dropdownRef}>
                                <input
                                    ref={searchInputRef}
                                    type="text"
                                    placeholder={
                                        loading
                                            ? 'Loading branches...'
                                            : 'Type to search branch by name or code...'
                                    }
                                    value={branchSearch}
                                    onChange={handleBranchSearchChange}
                                    onFocus={handleBranchSearchFocus}
                                    disabled={loading}
                                    className="branch-search-input"
                                />

                                <span className="search-icon-right" aria-hidden="true">
                                    <IoSearch />
                                </span>

                                {showBranchDropdown && !loading && (
                                    <div className="branch-dropdown-results">
                                        {allActiveBranches?.map((branch) => (
                                            <div
                                                key={branch.branch_code}
                                                className={`branch-dropdown-item ${formData.secondary_branch_code === branch.branch_code
                                                    ? 'selected'
                                                    : ''
                                                    }`}
                                                onClick={() => handleBranchSelect(branch)}
                                            >
                                                <div className="branch-item-name">
                                                    <strong>{branch.branch_name}</strong>
                                                </div>
                                                <div className="branch-item-code">
                                                    Branch Code: {branch.branch_code}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {selectedBranchDisplay && (
                                <small className="selected-branch-info">
                                    ✓ Selected: {selectedBranchDisplay}
                                </small>
                            )}
                        </div>
                    </div>

                    <div className="modal-actions">
                        <button
                            // type="submit"
                            type="button"
                            className="add-user-btn"
                            disabled={submitLoading || loading}
                            onClick={handleBranchAssignment}
                        >
                            {submitLoading ? 'Assigning...' : 'Assign'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AssignAnotherBranch